// Colors Object
const COLORS = [
    {
        "name": "amethyst",
        "code": "AME"
    },
    {
        "name": "aqua",
        "code": "AQU"
    },
    {
        "name": "aubergine",
        "code": "AUB"
    },
    {
        "name": "azure",
        "code": "AZU"
    },
    {
        "name": "ballet",
        "code": "BAL"
    },
    {
        "name": "beige-black-gold",
        "code": "BBG"
    },
    {
        "name": "bellini",
        "code": "BEL"
    },
    {
        "name": "berry",
        "code": "BER"
    },
    {
        "name": "black",
        "code": "BLK"
    },
    {
        "name": "black-blue",
        "code": "BKB"
    },
    {
        "name": "black-french-blue",
        "code": "BFB"
    },
    {
        "name": "black-gold",
        "code": "BGO"
    },
    {
        "name": "black-lime",
        "code": "BKL"
    },
    {
        "name": "black-multi",
        "code": "BKM"
    },
    {
        "name": "black-persimmon",
        "code": "BKP"
    },
    {
        "name": "blue",
        "code": "BLU"
    },
    {
        "name": "blue-green-multi",
        "code": "BGM"
    },
    {
        "name": "blue-steel",
        "code": "BST"
    },
    {
        "name": "blush",
        "code": "BLS"
    },
    {
        "name": "bordeaux",
        "code": "BOR"
    },
    {
        "name": "bronze",
        "code": "BRO"
    },
    {
        "name": "bronze-black",
        "code": "BRB"
    },
    {
        "name": "brown",
        "code": "BRN"
    },
    {
        "name": "butter",
        "code": "BUT"
    },
    {
        "name": "cafe",
        "code": "CAF"
    },
    {
        "name": "camel",
        "code": "CML"
    },
    {
        "name": "cayenne",
        "code": "CAY"
    },
    {
        "name": "cayenne-ruby",
        "code": "CRU"
    },
    {
        "name": "celadon",
        "code": "CEL"
    },
    {
        "name": "cerise",
        "code": "CER"
    },
    {
        "name": "champagne",
        "code": "CHA"
    },
    {
        "name": "charcoal",
        "code": "CHR"
    },
    {
        "name": "chocolate",
        "code": "CHO"
    },
    {
        "name": "chocolate-multi",
        "code": "CHM"
    },
    {
        "name": "cinnamon",
        "code": "CIN"
    },
    {
        "name": "cloud",
        "code": "CLD"
    },
    {
        "name": "cobalt",
        "code": "COB"
    },
    {
        "name": "cobalt-blue",
        "code": "COB"
    },
    {
        "name": "coco",
        "code": "COC"
    },
    {
        "name": "copper",
        "code": "COP"
    },
    {
        "name": "copper-sienna",
        "code": "CSI"
    },
    {
        "name": "coral",
        "code": "COR"
    },
    {
        "name": "coral-black",
        "code": "CRB"
    },
    {
        "name": "coral-fuchsia",
        "code": "CFU"
    },
    {
        "name": "cranberry",
        "code": "CRA"
    },
    {
        "name": "cream",
        "code": "CRE"
    },
    {
        "name": "crimson",
        "code": "CRI"
    },
    {
        "name": "custom color",
        "code": "CUS"
    },
    {
        "name": "dove",
        "code": "DOV"
    },
    {
        "name": "dusk",
        "code": "DUS"
    },
    {
        "name": "dusty-rose",
        "code": "DSR"
    },
    {
        "name": "ecru",
        "code": "ECR"
    },
    {
        "name": "eggplant",
        "code": "EGG"
    },
    {
        "name": "emerald",
        "code": "EME"
    },
    {
        "name": "endive",
        "code": "END"
    },
    {
        "name": "fawn",
        "code": "FWN"
    },
    {
        "name": "fig",
        "code": "FIG"
    },
    {
        "name": "fino-creme",
        "code": "FIC"
    },
    {
        "name": "fino-creme-ivory",
        "code": "FIV"
    },
    {
        "name": "forest",
        "code": "FOR"
    },
    {
        "name": "french-blue",
        "code": "FRE"
    },
    {
        "name": "french-blue-black",
        "code": "FBB"
    },
    {
        "name": "frost-green",
        "code": "FSG"
    },
    {
        "name": "fuchsia",
        "code": "FUC"
    },
    {
        "name": "fuchsia-black",
        "code": "FBK"
    },
    {
        "name": "fuchsia-coral",
        "code": "FCO"
    },
    {
        "name": "garnet",
        "code": "GAR"
    },
    {
        "name": "gold",
        "code": "GOL"
    },
    {
        "name": "gold-black",
        "code": "GBK"
    },
    {
        "name": "gold-gold",
        "code": "GGO"
    },
    {
        "name": "granite",
        "code": "GRN"
    },
    {
        "name": "grape",
        "code": "GRA"
    },
    {
        "name": "graphite",
        "code": "GPH"
    },
    {
        "name": "green",
        "code": "GRN"
    },
    {
        "name": "green-blue",
        "code": "GBU"
    },
    {
        "name": "grey",
        "code": "GRE"
    },
    {
        "name": "gunmetal",
        "code": "GUN"
    },
    {
        "name": "hot-pink",
        "code": "HPK"
    },
    {
        "name": "hunter",
        "code": "HUN"
    },
    {
        "name": "ice",
        "code": "ICE"
    },
    {
        "name": "ice-blue",
        "code": "ICB"
    },
    {
        "name": "ice-blue-multi",
        "code": "IBM"
    },
    {
        "name": "ice-green",
        "code": "IGN"
    },
    {
        "name": "indigo",
        "code": "IND"
    },
    {
        "name": "iris",
        "code": "IRS"
    },
    {
        "name": "ivory",
        "code": "IVY"
    },
    {
        "name": "ivory-blush",
        "code": "IVB"
    },
    {
        "name": "ivory-ivory",
        "code": "IIV"
    },
    {
        "name": "jade",
        "code": "JAD"
    },
    {
        "name": "lagoon",
        "code": "LAG"
    },
    {
        "name": "lake",
        "code": "LAK"
    },
    {
        "name": "latte",
        "code": "LAT"
    },
    {
        "name": "lavender",
        "code": "LAV"
    },
    {
        "name": "lilac",
        "code": "LIL"
    },
    {
        "name": "lilac-black",
        "code": "LBK"
    },
    {
        "name": "lilac-brown",
        "code": "LBR"
    },
    {
        "name": "lilac-mint",
        "code": "LMN"
    },
    {
        "name": "lilac-multi",
        "code": "LLM"
    },
    {
        "name": "lilac-silver",
        "code": "LLS"
    },
    {
        "name": "lime",
        "code": "LIM"
    },
    {
        "name": "lime-black",
        "code": "LMB"
    },
    {
        "name": "lime-ivory",
        "code": "LIV"
    },
    {
        "name": "linen",
        "code": "LIN"
    },
    {
        "name": "lipstick-red",
        "code": "LIP"
    },
    {
        "name": "magenta",
        "code": "MAG"
    },
    {
        "name": "mallard",
        "code": "MAL"
    },
    {
        "name": "mango",
        "code": "MNG"
    },
    {
        "name": "maple",
        "code": "MPL"
    },
    {
        "name": "marigold",
        "code": "MGD"
    },
    {
        "name": "marine",
        "code": "MRN"
    },
    {
        "name": "mauve",
        "code": "MAU"
    },
    {
        "name": "merlot",
        "code": "MRL"
    },
    {
        "name": "midnight",
        "code": "MID"
    },
    {
        "name": "mint",
        "code": "MIN"
    },
    {
        "name": "mint-ice-blue",
        "code": "MIB"
    },
    {
        "name": "mint-multi",
        "code": "MNM"
    },
    {
        "name": "mint-silver",
        "code": "MNS"
    },
    {
        "name": "mist",
        "code": "MIS"
    },
    {
        "name": "misty-grey-ivory",
        "code": "MGI"
    },
    {
        "name": "mocha",
        "code": "MOC"
    },
    {
        "name": "mocha-truffle",
        "code": "MTR"
    },
    {
        "name": "moss",
        "code": "MOS"
    },
    {
        "name": "mulberry",
        "code": "MUL"
    },
    {
        "name": "navy",
        "code": "NVY"
    },
    {
        "name": "navy-black",
        "code": "NBK"
    },
    {
        "name": "navy-multi",
        "code": "NVM"
    },
    {
        "name": "navy-navy",
        "code": "NNV"
    },
    {
        "name": "new-ice",
        "code": "NIC"
    },
    {
        "name": "nude",
        "code": "NUD"
    },
    {
        "name": "ocean",
        "code": "OCN"
    },
    {
        "name": "ocean-blue",
        "code": "OCB"
    },
    {
        "name": "ocean-multi",
        "code": "OCM"
    },
    {
        "name": "olive",
        "code": "OLI"
    },
    {
        "name": "olive-multi",
        "code": "OLM"
    },
    {
        "name": "onyx",
        "code": "ONY"
    },
    {
        "name": "orange",
        "code": "ORG"
    },
    {
        "name": "orange-multi",
        "code": "OGM"
    },
    {
        "name": "oyster",
        "code": "OYS"
    },
    {
        "name": "pacific",
        "code": "PAC"
    },
    {
        "name": "pale-blush",
        "code": "PLB"
    },
    {
        "name": "pale-fino",
        "code": "PLF"
    },
    {
        "name": "pansy",
        "code": "PAN"
    },
    {
        "name": "patina-black",
        "code": "PAB"
    },
    {
        "name": "peacock",
        "code": "PEA"
    },
    {
        "name": "pearl",
        "code": "PRL"
    },
    {
        "name": "pecan",
        "code": "PCN"
    },
    {
        "name": "peony",
        "code": "PEO"
    },
    {
        "name": "periwinkle",
        "code": "PER"
    },
    {
        "name": "persimmon",
        "code": "PRS"
    },
    {
        "name": "persimmon-gold",
        "code": "PGO"
    },
    {
        "name": "petal",
        "code": "PTL"
    },
    {
        "name": "petrol",
        "code": "PET"
    },
    {
        "name": "pewter",
        "code": "PEW"
    },
    {
        "name": "pink",
        "code": "PNK"
    },
    {
        "name": "platinum",
        "code": "PLT"
    },
    {
        "name": "plum",
        "code": "PLM"
    },
    {
        "name": "poppy",
        "code": "POP"
    },
    {
        "name": "powder",
        "code": "POW"
    },
    {
        "name": "purple",
        "code": "PUR"
    },
    {
        "name": "purple-black",
        "code": "PBK"
    },
    {
        "name": "rain",
        "code": "RAI"
    },
    {
        "name": "raspberry",
        "code": "RAS"
    },
    {
        "name": "red",
        "code": "RED"
    },
    {
        "name": "red-ivory",
        "code": "RIV"
    },
    {
        "name": "rose",
        "code": "ROS"
    },
    {
        "name": "rose-gold",
        "code": "ROG"
    },
    {
        "name": "rose-quartz",
        "code": "ROQ"
    },
    {
        "name": "rosette",
        "code": "RST"
    },
    {
        "name": "rosewater",
        "code": "RSW"
    },
    {
        "name": "royal",
        "code": "ROY"
    },
    {
        "name": "ruby",
        "code": "RUB"
    },
    {
        "name": "ruby-cayenne",
        "code": "RCA"
    },
    {
        "name": "sable",
        "code": "SBL"
    },
    {
        "name": "sage",
        "code": "SAG"
    },
    {
        "name": "salmon",
        "code": "SAL"
    },
    {
        "name": "sand",
        "code": "SAN"
    },
    {
        "name": "sepia",
        "code": "SEP"
    },
    {
        "name": "shell",
        "code": "SHL"
    },
    {
        "name": "silk-white",
        "code": "SWH"
    },
    {
        "name": "sienna",
        "code": "SIE"
    },
    {
        "name": "sienna-copper",
        "code": "SCO"
    },
    {
        "name": "sienna-multi",
        "code": "SIM"
    },
    {
        "name": "slate",
        "code": "SLA"
    },
    {
        "name": "smoke",
        "code": "SMO"
    },
    {
        "name": "smoky-blue",
        "code": "SMB"
    },
    {
        "name": "spa",
        "code": "SPA"
    },
    {
        "name": "steel-blue",
        "code": "STL"
    },
    {
        "name": "stone",
        "code": "STO"
    },
    {
        "name": "sunset-multi",
        "code": "STM"
    },
    {
        "name": "tangerine",
        "code": "TAN"
    },
    {
        "name": "taupe",
        "code": "TAU"
    },
    {
        "name": "teal",
        "code": "TEA"
    },
    {
        "name": "teal-navy",
        "code": "TNV"
    },
    {
        "name": "thistle",
        "code": "THS"
    },
    {
        "name": "topaz",
        "code": "TOP"
    },
    {
        "name": "truffle",
        "code": "TRU"
    },
    {
        "name": "truffle-mocha",
        "code": "TMO"
    },
    {
        "name": "turquoise",
        "code": "TUR"
    },
    {
        "name": "twilight",
        "code": "TWI"
    },
    {
        "name": "vanilla",
        "code": "VAN"
    },
    {
        "name": "vintage-ice",
        "code": "VCE"
    },
    {
        "name": "violet",
        "code": "VIO"
    },
    {
        "name": "watermelon",
        "code": "WAT"
    },
    {
        "name": "wedgewood",
        "code": "WED"
    },
    {
        "name": "wheat-silver",
        "code": "WHS"
    },
    {
        "name": "white",
        "code": "WHT"
    },
    {
        "name": "willow",
        "code": "WLL"
    },
    {
        "name": "wine",
        "code": "WIN"
    },
    {
        "name": "wisteria",
        "code": "WIS"
    },
];

const SIZE = [
    'X-SMALL',
    'SMALL',
    'MEDIUM',
    'LARGE',
    'X-LARGE',
    'XX-LARGE',
    'MM',
    'SS'
];

$(function () {
    // Get current SKU
    const current_sku = $('input[type=hidden]#hidden-product-sku').val();
    const product_type = $('input[type=hidden]#hidden-product-type').val();
    const selected_options = {
        "sku": current_sku,
        "dress_size": '',
        "dress_length": '',
        "color": ""
    };

    // Get SessionStorage object
    const current_session = sessionStorage.getItem("selected_options");

    // Reinitilialize Session if SKU is different
    if (current_session && (current_sku !== JSON.parse(current_session).sku)) {
        sessionStorage.setItem("selected_options", JSON.stringify(selected_options));
    }

    // Variant options Event Listeners
    if ($('.product_single_form').length > 0) {
        if (product_type !== 'fabric') {
            setGlobalSku();
        }

        if ($('.product-form__selects.product-select--size').length > 0) {
            $(document).on('change', '.product-form__selects.product-select--size select', function(){
                if ($(this).val() != '') {
                    setGlobalSku($(this).val());
                }
            });
        } else {
            document.arrive(".infinite-option-size-select select", function () {
                $(this).change(function (e) {
                    if ($(this).val() != '') {
                        setGlobalSku($(this).val());
                    }
                });
            });
        }

        if ($('.product-form__selects.product-select--dress-length').length > 0) {
            $(document).on('change', '.product-form__selects.product-select--dress-length select', function(){
                if ($(this).val() !== '') {
                    setGlobalSku('', $(this).val());
                }
            });
        }

        if ($('.colorSelector.form-control').length > 0) {
            $(document).on('click keyup', '.colorSelector .swatch-element', function(e){
                if (e.type == 'click' || (e.type == 'keyup' && e.keyCode == 13)) {
                    setGlobalSku();
                }
            });
        }
    }
});

function setGlobalSku(dress_size = '', dress_length = '') {
    // Initialize variables
    const productionGlobalSkuProp = $('input[type=hidden]#product-properties-global-sku')
    const isRtw = $('#hidden-is-rtw').val()
    let globalSKU = {
        "sku": $('input[type=hidden]#hidden-product-sku').val(),
        "dress_size": '',
        "dress_length": '',
        "color": ""
    };

    // Get SessionStorage object
    const current_session = sessionStorage.getItem("selected_options");

    // Set each option value

    // Selected Color
    globalSKU.color = (current_session && JSON.parse(current_session).color !== "") ? getColorCode(JSON.parse(current_session).color) : getColorCode((getSelectedColor() !== false) ? getSelectedColor() : 'Ivory');

    // Selected Size
    if (dress_size !== '' && dress_size !== null) {
        globalSKU.dress_size = isNumber(dress_size) ? dress_size : dress_size.toUpperCase();
    } else {
        globalSKU.dress_size = (current_session && JSON.parse(current_session).dress_size !== "") ? isNumber(JSON.parse(current_session).dress_size) ? JSON.parse(current_session).dress_size : JSON.parse(current_session).dress_size : getSize();
    }

    // Selected Length
    if (dress_length !== '') {
        globalSKU.dress_length = dress_length == 'Standard' ? "" : "-XL";
    } else {
        globalSKU.dress_length = (current_session && JSON.parse(current_session).dress_length !== "") ? JSON.parse(current_session).dress_length == 'Standard' ? "" : "-XL" : getDressLength();
    }


    // GlobalSKU.. ASSEMBLE!!
    if (isRtw == 'true') {
      productionGlobalSkuProp.val(globalSKU.sku)
    } else {
      productionGlobalSkuProp.val(`${globalSKU.sku}-${globalSKU.color}${(globalSKU.dress_size !== '') ? "-" + globalSKU.dress_size : ''}${globalSKU.dress_length}`);
    }
}

// Return Color Code
function getColorCode(current_color) {
    if (current_color !== undefined) {
        const obj = COLORS.find(o => o.name === parseColor(current_color));
        // Return blank if there was a typo in Color name
        if (!obj) return '';
        // Return Color Code if found
        return obj.code;
    }
    return '';
}

// Parse string to remove forward slash and spaces
function parseColor(current_color) {
    let color = current_color;

    if (current_color !== undefined) {
        if (/(?=(.*[ /]))/.test(current_color)) {
            color = current_color.replace(' ', '-').replace('/', '-');
        }
        return color.toLowerCase();
    }
    return '';
}

// Return selected Color
function getSelectedColor() {
    let element = null;

    if ($('.colorSelector').length > 0) {
        element = $('.colorSelector');
    } else if ($('.product-form__selects.product-select--color').length > 0) {
        element = $('.product-form__selects.product-select--color');
    }

    if (element) {
        if (element.hasClass('colorSelector')) {
            return element.find('.active-swatch').attr('data-colorname-value');
        } else {
            return element.find('select.single-option-selector').val();
        }
    }

    return false;
}

// Return selected Size
function getSize() {
    let select_dropdown = null;

    if ($(".infinite-option-size-select select").length > 0) {
        select_dropdown = $(".infinite-option-size-select select");
    } else {
        select_dropdown = $('.product-form__selects.product-select--size select');
    }

    if (select_dropdown.length > 0 && (select_dropdown.val() !== null && (select_dropdown.val() !== ''))) {
        return isNumber(select_dropdown.val()) ? select_dropdown.val() : select_dropdown.val().toUpperCase();
    }

    return '';
}

// Validate if Size is a Number
function isNumber(n) { return /^-?[\d.]+(?:e-?\d+)?$/.test(n); }

// Return selected Dress length
function getDressLength() {
    if ($(".product-form__selects.product-select--dress-length select").length > 0) {
        if ($(".product-form__selects.product-select--dress-length select").val() !== '') {
            return $(".product-form__selects.product-select--dress-length select").val() == 'Standard' ? '' : '-XL';
        }
    }

    return '';
}
